import axiosInstance from "../axiosInstance";

export const getTagsApi = () => {
  return axiosInstance.get(`/api/tags`);
};
